import { createFileRoute } from "@tanstack/react-router";

import { RequirePermission } from "@/hooks/shared/CheckAuth";
import { LeaveTypeFormPage } from "@/pages/dashboard/leave-types/form";

export const Route = createFileRoute("/_main/dashboard/leave-types/$id/edit")({
  component: () => (
    <RequirePermission action="lookups.manage">
      <LeaveTypeFormPage />
    </RequirePermission>
  ),
});
